import { z } from 'my-zod'
import { outfitterWaiverContentSystemView } from './outfitter-waiver-content-system-view'

export const outfitterWaiverContentResolvedView = z.object({
  id: z.string().uuid(),
  versionId: z.number(),
  name: z.string(),
  outfitterId: outfitterWaiverContentSystemView.shape.outfitterId,
  isoLanguageCode: outfitterWaiverContentSystemView.shape.language,
  legacyProductLine: outfitterWaiverContentSystemView.shape.legacyProductLine,
  legacyCustomProduct: outfitterWaiverContentSystemView.shape.legacyCustomProduct,
  compatibleProductLines: outfitterWaiverContentSystemView.shape.compatibleProductLines,
  compatibleCustomAssetClasses: outfitterWaiverContentSystemView.shape.compatibleCustomAssetClasses,
  productImage: outfitterWaiverContentSystemView.shape.productImage,
  waiverAgreement: z.string(),
  waiverAgreementVersion: z.ostring(),
  overviewQ1: outfitterWaiverContentSystemView.shape.overviewQ1,
  overviewQ2: outfitterWaiverContentSystemView.shape.overviewQ2,
  overviewQ3: outfitterWaiverContentSystemView.shape.overviewQ3,
  overviewQ4: outfitterWaiverContentSystemView.shape.overviewQ4,
  overviewQ5: outfitterWaiverContentSystemView.shape.overviewQ5,
  overviewQ6: outfitterWaiverContentSystemView.shape.overviewQ6,
  safetyVideoUrl: outfitterWaiverContentSystemView.shape.safetyVideoUrl,
  checkoutSafetyQ1: outfitterWaiverContentSystemView.shape.checkoutSafetyQ1,
  checkoutSafetyQ2: outfitterWaiverContentSystemView.shape.checkoutSafetyQ2,
  checkoutSafetyQ3: outfitterWaiverContentSystemView.shape.checkoutSafetyQ3,
  checkoutSafetyQ4: outfitterWaiverContentSystemView.shape.checkoutSafetyQ4,
  checkoutSafetyQ5: outfitterWaiverContentSystemView.shape.checkoutSafetyQ5,
  checkoutSafetyQ6: outfitterWaiverContentSystemView.shape.checkoutSafetyQ6,
  lastModifiedDate: outfitterWaiverContentSystemView.shape.lastModifiedDate,
  driverMinimumAge: outfitterWaiverContentSystemView.shape.driverMinimumAge,
  ageToCarryMinorPassenger: outfitterWaiverContentSystemView.shape.ageToCarryMinorPassenger,
  rideLanguageType: z.enum(['Generic', 'RideSpecific']),
  requireMotorcycleLicense: z.boolean(),
  additionalWaiverQuestions: outfitterWaiverContentSystemView.shape.additionalWaiverQuestions
})

export type outfitterWaiverContentResolvedView = z.infer<typeof outfitterWaiverContentResolvedView>
